import Header from '@/features/pos/components/ProductConfigurationModal/parts/OptionGroup/parts/Header'
import { getSelectionRuleTranslation } from '@/features/pos/components/ProductConfigurationModal/parts/OptionGroup/utils/getSelectionRuleTranslation'
import { FC, ReactNode, memo } from 'react'
import { useTranslation } from 'react-i18next'
import { View } from 'react-native'

interface OptionGroupProps {
    children: ReactNode
    name: string
    minQuantity: number
    maxQuantity: number | null
}

const OptionGroup: FC<OptionGroupProps> = ({ children, name, minQuantity, maxQuantity }) => {
    const { t } = useTranslation()

    return (
        <View style={{ gap: 8 }}>
            <Header
                name={name}
                selectionRule={getSelectionRuleTranslation(minQuantity, maxQuantity, t)}
                required={minQuantity > 0}
            />
            {children}
        </View>
    )
}

export default memo(OptionGroup)
